import { render, staticRenderFns } from "./ClientShippingSettings.vue?vue&type=template&id=0da82e84&"
import script from "./ClientShippingSettings.vue?vue&type=script&lang=ts&"
export * from "./ClientShippingSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports